import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["emailInput", "emailOutput", "roleInput", "roleOutput"]

  connect() {
    this.refresh()
  }

  refresh() {
    if (this.hasEmailOutputTarget) {
      this.emailOutputTarget.textContent = this.emailInputTarget.value || "Not entered"
    }

    if (this.hasRoleOutputTarget) {
      this.roleOutputTarget.textContent = this.selectedRoleLabel
    }
  }

  get selectedRoleLabel() {
    const selectedRole = this.roleInputTargets.find((input) => input.checked)

    return selectedRole?.dataset.onboardingReviewLabel || "Spectator"
  }
}
